import React from 'react';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import styles from './TabNav.module.scss';

class TabNav extends React.Component {
  constructor (props) {
    super(props);
    this.state = {

    };
  }
  render () {
    const location = window.location;
    const pathName = location.pathname;
    const tabItems = this.props.tabItems;
    return <div className={styles.tabContainer}>
      <ul className={styles.tabs}>
        {tabItems.map(item => <li key={item.title}>
          <NavLink
            key={item.title}
            to={`${item.path}`}
            className={item.path === pathName ? styles.active : null}
          >
            {item.title}
          </NavLink>
        </li>)}
      </ul>
    </div>;
  }
};

export default TabNav;

TabNav.propTypes = {
  tabItems: PropTypes.array
};
